import React from 'react';
import { Stepper as SharedStepper } from '@triumph/shared';
import { useDispatch, useSelector } from 'react-redux';
import { getStep, getCompletedSteps } from 'src/redux/app/selectors';
import steps from 'src/config/steps.config';
import { Outer, Wrap } from './Stepper.styled';
import { setStep } from 'src/redux/app/actions';
import useDataLayer from 'src/hooks/useDataLayer';
import useLabel from 'src/hooks/useLabel';

const Stepper = () => {
  const dispatch = useDispatch();
  const pushToDataLayer = useDataLayer();
  const getLabel = useLabel();
  const activeStep = useSelector(getStep);
  const completedSteps = useSelector(getCompletedSteps);

  return (
    <Outer>
      <Wrap>
        <SharedStepper
          steps={steps}
          activeStep={activeStep}
          completedSteps={completedSteps}
          allDisabled={completedSteps.length === 3}
          onChange={({ activeStep: newActiveStep }) => {
            dispatch(setStep(newActiveStep));
            pushToDataLayer('journeyLine', {
              sectionEdit: getLabel(steps.find(step => step.number === newActiveStep)?.labelKey),
            });
          }}
          linear
        />
      </Wrap>
    </Outer>
  );
};

export default Stepper;
